import { useSyncExternalStore } from 'react';

export const EDITOR_OVERLAY_ATTRIBUTE = 'data-editor-overlay';

const EDITOR_OVERLAY_SELECTOR = `[${EDITOR_OVERLAY_ATTRIBUTE}]`;

let cachedBlocked: boolean | null = null;
const listeners = new Set<() => void>();
let observer: MutationObserver | null = null;

function readBlocked(): boolean {
  if (typeof document === 'undefined') {
    return false;
  }
  return document.querySelector(EDITOR_OVERLAY_SELECTOR) !== null;
}

function getSnapshot(): boolean {
  if (cachedBlocked === null) {
    cachedBlocked = readBlocked();
  }
  return cachedBlocked;
}

function getServerSnapshot(): boolean {
  return false;
}

function emitChange(): void {
  const next = readBlocked();
  if (next === cachedBlocked) {
    return;
  }
  cachedBlocked = next;
  listeners.forEach((listener) => listener());
}

function ensureObserver(): void {
  if (observer || typeof MutationObserver === 'undefined' || typeof document === 'undefined') {
    return;
  }
  observer = new MutationObserver(() => {
    emitChange();
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: [EDITOR_OVERLAY_ATTRIBUTE],
  });
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  ensureObserver();
  cachedBlocked = readBlocked();
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0) {
      observer?.disconnect();
      observer = null;
      cachedBlocked = null;
    }
  };
}

export function useIsFormattingBarBlocked(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
